import { ReactNode } from 'react';
import NavigationButton, { NavigationButtonProps } from './NavigationButton';

export interface WwwNavigationProps
  extends Omit<NavigationButtonProps, 'icon'> {
  children?: ReactNode;
}

export const WwwNavigation = ({
  label,
  id,
  onClick,
  active = false,
  children,
}: WwwNavigationProps) => {
  return (
    <NavigationButton
      icon='ri:building-fill'
      label={label}
      id={id}
      onClick={onClick}
      active={active}
    >
      {children}
    </NavigationButton>
  );
};

export default WwwNavigation;
